import script from "./UpLogAnaquel.vue?vue&type=script&lang=ts&setup=true"
export * from "./UpLogAnaquel.vue?vue&type=script&lang=ts&setup=true"

import "./UpLogAnaquel.vue?vue&type=style&index=0&id=7e27afcf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e27afcf"]])

export default __exports__